import { Form } from "antd";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";

const OfficerReportLocationSection = ({ report = {} }) => {
  return (
    <Form
      layout="vertical"
      initialValues={{
        facility: report.facility || "",
        block: report.block || "",
        cell: report.cell || "",
        bed: report.bed || "",
        location: report.location || "",
      }}
    >
      <StyledGridRow gutter={16} justify={'start'}>
        <StyledGridCol lg={4}>
          <FormItem label="Facility" name="facility">
            <TextField />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={4}>
          <FormItem label="Block" name="block">
            <Select
              options={getOptionsFromRefList("Block", false, false, true)}
              placeholder="Select Block"
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={4}>
          <FormItem label="Cell" name="cell">
            <Select
              options={getOptionsFromRefList("Cell", false, false, true)}
              placeholder="Select Cell"
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={4}>
          <FormItem label="Bed" name="bed">
            <Select
              options={getOptionsFromRefList("Bed", false, false, true)}
              placeholder="Select Bed"
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={7}>
          <FormItem label="Incident Location" name="location">
            <Select
              options={getOptionsFromRefList("IncidentLocationCode", false, false, true)}
              placeholder="Select Incident Location"
            />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
    </Form>
  );
};

export default OfficerReportLocationSection;
